import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/varietyShows";

export default function Breadcrumb() {
  const location = useLocation();
  const pathSegments = location.pathname.split("/").filter(Boolean);

  if (pathSegments.length === 0) return null;

  const breadcrumbs = [{ label: "首页", path: "/" }];

  if (pathSegments[0] === "category") {
    const category = categories.find((c) => c.slug === pathSegments[1]);
    breadcrumbs.push({
      label: category ? category.name : "分类浏览",
      path: `/category/${pathSegments[1] || ""}`,
    });
  } else if (pathSegments[0] === "article") {
    breadcrumbs.push({ label: "节目详情", path: location.pathname });
  } else if (pathSegments[0] === "about") {
    breadcrumbs.push({ label: "关于我们", path: "/about" });
  }

  return (
    <nav aria-label="面包屑导航" className="w-full px-4 md:px-6 pt-24 pb-2">
      <div className="max-w-7xl mx-auto">
        <ol className="flex items-center gap-2 text-sm flex-wrap">
          {breadcrumbs.map((item, index) => (
            <li key={item.path} className="flex items-center gap-2">
              {index > 0 && (
                <i className="ri-arrow-right-s-line text-foreground-300 text-xs w-3 h-3 flex items-center justify-center"></i>
              )}
              {index === breadcrumbs.length - 1 ? (
                <span className="text-foreground-500">{item.label}</span>
              ) : (
                <Link
                  to={item.path}
                  className="text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {item.label}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </div>
    </nav>
  );
}